import { render, staticRenderFns } from "./MultipleProblem.vue.js?vue&type=template&id=f5a957a6&scoped=true!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MultipleProblem.vue?vue&type=template&id=f5a957a6&scoped=true"
import script from "./MultipleProblem.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MultipleProblem.vue?vue&type=script&lang=js"
export * from "./MultipleProblem.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MultipleProblem.vue?vue&type=script&lang=js"
import style0 from "./MultipleProblem.vue.css?vue&type=style&index=0&id=f5a957a6&prod&lang=css&scoped=true!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MultipleProblem.vue?vue&type=style&index=0&id=f5a957a6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a957a6",
  null
  
)

export default component.exports